


































import Vue from 'vue';
import Component from 'vue-class-component';
import {ChallengeDescriptionBlock, ChallengeModel, Translated} from '@/models/challenge.model';
import {challengeModule, i18nModule} from '@/utils/store-acessor';
import {LocaleSelectorType} from '@/store/i18n.store.module';
import {compare, vimeoUrlParser, youtubeUrlParser} from "@/utils/utils";
import ChallengerDetailDescriptionTrophy
  from "@/components/Challenges/tabs/description/ChallengerDetailDescriptionTrophy.vue";

@Component({
  components: {ChallengerDetailDescriptionTrophy}
})
export default class ChallengerDetailDescription extends Vue {
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel | null;
  @i18nModule.Getter('locale') locale!: LocaleSelectorType;

  get descriptionBlocksOrdered(): ChallengeDescriptionBlock[] {
    if (!!this.challenge?.description_blocks) {
      return this.challenge.description_blocks.sort((a, b) => compare(a.id, b.id, true))
    }
    return []
  }

  get challengeDescription(): string {
    const locale = this.locale.value;
    const description = this.challenge?.description as Translated;
    if (!!description) {
      switch (locale) {
        case 'en':
          // @ts-ignore
          return description.en || description;
        case 'ptBr':
          // @ts-ignore
          return description.pt || description
      }
    }
    return '';
  }

  getVideoUrl(url: string): string {
    const youtubeId = youtubeUrlParser(url);
    if (youtubeId) {
      return `https://www.youtube.com/embed/${youtubeId}`
    } else {
      const vimeoId = vimeoUrlParser(url)
      return `https://player.vimeo.com/video/${vimeoId}`
    }

  }
}
